export class HealthUnitProtocolRequest{
    public idHealthUnit:number;
    public listIdProtocol:number[];
}